import {
  ProductClubeFillLargeIcon,
  ProductHealthFillLargeIcon,
  ProductPetFillLargeIcon,
  ProductPosthumousFillLargeIcon,
  Section,
  TitleAndDescription,
  token,
} from '@ferreri/prever-component-lib';

import * as routes from '../routes';
import { CardProductList } from './CardProductList';

export const ProductsSection = () => (
  <Section>
    <TitleAndDescription
      title="Produtos Angeplus"
      description="Usufrua dos benefícios de ser associado"
    />
    <CardProductList data={Object.values(SERVICES)} />
  </Section>
);

const SERVICES = {
  pet: {
    title: 'Para seu Pet',
    icon: <ProductPetFillLargeIcon color={token.colors.solidPetPrimaryPure} />,
    uri: routes.TELEVET,
  },
  health: {
    title: 'Cuidados e Saúde',
    icon: (
      <ProductHealthFillLargeIcon color={token.colors.solidSaudePrimaryPure} />
    ),
    uri: routes.HEALTH,
  },
  posthumous: {
    title: 'Serviços Funerários',
    icon: (
      <ProductPosthumousFillLargeIcon
        color={token.colors.solidPostumosPrimaryPure}
      />
    ),
    uri: routes.POSTHUMOUS,
  },
  clube: {
    title: 'Clube de Vantagens',
    icon: (
      <ProductClubeFillLargeIcon color={token.colors.solidClubePrimaryPure} />
    ),
    uri: routes.CLUBE,
  },
};
